import { connect } from 'react-redux';
import ProfilePicture from '../components/ProfilePicture';
import { useId, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CurrentIndexDotIndicator from '../components/CurrentIndexDotIndicator';

const MyTest = ({
}) => {
    const componentId = useId();
    const previews = [
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        },
        {
            id: '',
        }
    ]

    const [previewIndex, setPreviewIndex] = useState(0);

    const navigate = useNavigate();

    const indexInViewport = (index) => {
        if (index >= 0 && index < previews.length) {
            setPreviewIndex(index);
        }
    }
    const getUniqueScrollToId = (id) => {
        return `${componentId}-${id}`;
    }

    const prevPreview = () => {
        const newIndex = Math.max(0, previewIndex - 1);
        const elem = document.getElementById(getUniqueScrollToId(previews[newIndex].id));
        if (elem) {
            elem.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: "start" });
        }
    }

    const nextPreview = () => {
        const newIndex = Math.min(previews.length - 1, previewIndex + 1);
        const elem = document.getElementById(getUniqueScrollToId(previews[newIndex].id));
        if (elem) {
            elem.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: "start" });
        }
    }

    return (
        <div className='container'>
            <table style={{ width: "100%", padding: "20px" }}>
                <tbody>
                    <tr>
                        <td style={{ width: "100%", textAlign: "left" }}>
                            <img src="/appname.png" style={{ verticalAlign: "middle", height: "30px" }} />
                        </td>
                        <td style={{ minWidth: "160px", textAlign: "right" }}>
                            <button style={{ verticalAlign: "middle" }}>
                                <div style={{ verticalAlign: "middle", height: "36px", backgroundColor: "var(--app-surface)", borderRadius: "36px" }}>
                                    <span style={{ display: "inline-block", fontSize: "14px", fontWeight: 500, verticalAlign: "middle", padding: "8px 16px" }}>edit</span>
                                </div>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>
                <div className='heading' style={{ padding: '0px 20px 8px' }}>
                    For you
                </div>
                <div id={componentId} style={{ margin: '0px 0px', borderRadius: '10px', scrollPadding: '0px' }} className='hslider-container hideScrollbar horizontalScroll'>
                    <span className='hslider-children'>
                        <div style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', alignItems: 'center', padding: '10px 20px', width: '100%' }}>
                                <div>
                                    <ProfilePicture
                                        speakerId={'wiki_34324591'}
                                        borderSize={1}
                                        imageSrc={"https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/photos%2Fwiki_34324591.png?alt=media"}
                                        size='40px'
                                        margin='0px 10px 0px 0px' />
                                </div>
                                <div style={{ flexGrow: 1 }}>
                                    <div className="previewInfoSpeakerName">Keith Rabois</div>
                                    <div className="previewInfoSpeakerDescription">American technology executive and investor, managing director at Khosla Ventures</div>
                                </div>

                            </div>
                            <div style={{ padding: '0px 0px' }}>
                                <video autoPlay loop muted playsInline poster='/test/video.png' style={{ borderRadius: '0px', width: '100%' }}>
                                    <source src='/test/video.mp4' type='video/mp4' />
                                </video>
                                <img className='podcastArtwork' src='https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/srcimg%2Fcdf0781b-0818-4c19-bfcd-f12108139453.png?alt=media' alt='logo' style={{ position: 'absolute', objectFit: 'contain', bottom: '8px', right: '4px', width: '40px', height: '40px' }} />
                            </div>
                        </div>

                        <div style={{ padding: '0px 20px' }} >
                            <div className='previewInfoTitle' style={{ margin: '6px 0px 3px' }}>
                                Why Predicting Elections Is Easier Than Rocket Science
                            </div>
                            <div className="footnote">
                                <div><span style={{ verticalAlign: 'middle' }}>27s</span><span style={{ padding: '0px 6px', verticalAlign: 'middle' }}>·</span><span style={{ verticalAlign: 'middle' }}>Jun 11, 2024</span>
                                </div>
                            </div>
                        </div>
                    </span>

                    <span className='hslider-children'>
                        <div style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', alignItems: 'center', padding: '10px 20px', width: '100%' }}>
                                <div>
                                    <ProfilePicture
                                        speakerId={'wiki_51277767'}
                                        borderSize={1}
                                        imageSrc={"https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/photos%2Fwiki_51277767.png?alt=media"}
                                        size='40px'
                                        margin='0px 10px 0px 0px' />
                                </div>
                                <div>
                                    <div className="previewInfoSpeakerName">Andrew Huberman</div>
                                    <div className="previewInfoSpeakerDescription">American neuroscientist and podcaster</div>
                                </div>
                            </div>
                            <div style={{ padding: '0px 0px' }}>
                                <video autoPlay loop muted playsInline poster='/test/video2.png' style={{ borderRadius: '0px', width: '100%' }}>
                                    <source src='/test/video2.mp4' type='video/mp4' />
                                </video>
                                <img className='podcastArtwork' src='https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/srcimg%2F3ae22bef-a969-43fc-b960-421a2b06d7cc.png?alt=media' alt='logo' style={{ position: 'absolute', objectFit: 'contain', bottom: '8px', right: '4px', width: '40px', height: '40px' }} />
                            </div>
                        </div>

                        <div style={{ padding: '0px 16px 16px' }} >
                            <div className='previewInfoTitle' style={{ margin: '6px 0px 3px' }}>
                                Boost Your Metabolism While Sitting At Your Desk
                            </div>
                            <div className="footnote">
                                <div><span style={{ verticalAlign: 'middle' }}>37s</span><span style={{ padding: '0px 6px', verticalAlign: 'middle' }}>·</span><span style={{ verticalAlign: 'middle' }}>Mar 8, 2023</span>
                                </div>
                            </div>
                        </div>
                    </span>
                </div>
                {previews.length > 1 &&
                    <CurrentIndexDotIndicator
                        currentIndex={previewIndex}
                        maxIndex={previews.length - 1}
                        onNextClick={nextPreview}
                        onPrevClick={prevPreview}
                    />
                }
            </div>
            <div>
                <div className='heading' style={{ padding: '20px 0px 8px 0px', marginTop: '20px', marginLeft: '20px', borderTop: '1px solid var(--app-separator)' }}>
                    fitness
                </div>
                <div id={componentId} style={{ margin: '0px 0px', borderRadius: '10px', scrollPadding: '0px' }} className='hslider-container hideScrollbar horizontalScroll'>
                    <span className='hslider-children'>
                        <div style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', alignItems: 'center', padding: '10px 16px', width: '100%' }}>
                                <div>
                                    <ProfilePicture
                                        speakerId={'wiki_51277767'}
                                        borderSize={1}
                                        imageSrc={"https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/photos%2Fwiki_51277767.png?alt=media"}
                                        size='40px'
                                        margin='0px 10px 0px 0px' />
                                </div>
                                <div>
                                    <div className="previewInfoSpeakerName">Andrew Huberman</div>
                                    <div className="previewInfoSpeakerDescription">American neuroscientist and podcaster</div>
                                </div>
                            </div>
                            <div style={{ padding: '0px 0px' }}>
                                <video autoPlay loop muted playsInline poster='/test/video2.png' style={{ borderRadius: '0px', width: '100%' }}>
                                    <source src='/test/video2.mp4' type='video/mp4' />
                                </video>
                                <img className='podcastArtwork' src='https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/srcimg%2F3ae22bef-a969-43fc-b960-421a2b06d7cc.png?alt=media' alt='logo' style={{ position: 'absolute', objectFit: 'contain', bottom: '8px', right: '4px', width: '40px', height: '40px' }} />
                            </div>
                        </div>

                        <div style={{ padding: '0px 16px 16px' }} >
                            <div className='previewInfoTitle' style={{ margin: '6px 0px 3px' }}>
                                Boost Your Metabolism While Sitting At Your Desk
                            </div>
                            <div className="footnote">
                                <div><span style={{ verticalAlign: 'middle' }}>37s</span><span style={{ padding: '0px 6px', verticalAlign: 'middle' }}>·</span><span style={{ verticalAlign: 'middle' }}>Mar 8, 2023</span>
                                </div>
                            </div>
                        </div>
                    </span>
                    <span className='hslider-children'>
                        <div style={{ position: 'relative' }}>
                            <div style={{ display: 'flex', alignItems: 'center', padding: '10px 20px', width: '100%' }}>
                                <div>
                                    <ProfilePicture
                                        speakerId={'wiki_34324591'}
                                        borderSize={1}
                                        imageSrc={"https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/photos%2Fwiki_34324591.png?alt=media"}
                                        size='40px'
                                        margin='0px 10px 0px 0px' />
                                </div>
                                <div style={{ flexGrow: 1 }}>
                                    <div className="previewInfoSpeakerName">Keith Rabois</div>
                                    <div className="previewInfoSpeakerDescription">American technology executive and investor, managing director at Khosla Ventures</div>
                                </div>

                            </div>
                            <div style={{ padding: '0px 0px' }}>
                                <video autoPlay loop muted playsInline poster='/test/video.png' style={{ borderRadius: '0px', width: '100%' }}>
                                    <source src='/test/video.mp4' type='video/mp4' />
                                </video>
                                <img className='podcastArtwork' src='https://firebasestorage.googleapis.com/v0/b/twinklepoo/o/srcimg%2Fcdf0781b-0818-4c19-bfcd-f12108139453.png?alt=media' alt='logo' style={{ position: 'absolute', objectFit: 'contain', bottom: '8px', right: '4px', width: '40px', height: '40px' }} />
                            </div>
                        </div>

                        <div style={{ padding: '0px 20px' }} >
                            <div className='previewInfoTitle' style={{ margin: '6px 0px 3px' }}>
                                Why Predicting Elections Is Easier Than Rocket Science
                            </div>
                            <div className="footnote">
                                <div><span style={{ verticalAlign: 'middle' }}>27s</span><span style={{ padding: '0px 6px', verticalAlign: 'middle' }}>·</span><span style={{ verticalAlign: 'middle' }}>Jun 11, 2024</span>
                                </div>
                            </div>
                        </div>
                    </span>
                </div>
                {previews.length > 1 &&
                    <CurrentIndexDotIndicator
                        currentIndex={previewIndex}
                        maxIndex={previews.length - 1}
                        onNextClick={nextPreview}
                        onPrevClick={prevPreview}
                    />
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(MyTest);
